import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import { toast } from "@teamprevent/common/toasts";

import SignUpRequestApi from "./SignUpRequestApi";
import * as actions from "./actionTypes";

export type RequestSignUpEmailAction = ({ type: typeof actions.REQUEST_SIGNUP_EMAIL_SUCCESS } & Payload<string>);
export type ResetUserEmailAction = ({ type: typeof actions.RESET_USER_EMAIL_SUCCESS } & Payload<string>);

export function requestCustomerUserSignUpEmail(customerUserId: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, actions.REQUEST_CUSTOMER_USER_SIGNUP_EMAIL, SignUpRequestApi.requestCustomerUserEmail(customerUserId));
        dispatch(requestSignUpEmailSuccess(customerUserId));
        toast.success("Invite Email Sent");
    };
}

export function requestEmployeeSignUpEmail(customerUserId: string, employeeId: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, actions.REQUEST_EMPLOYEE_SIGNUP_EMAIL,
            SignUpRequestApi.requestEmployeeEmail(customerUserId, employeeId));
        dispatch(requestSignUpEmailSuccess(employeeId));
        toast.success("Invite Email Sent.");
    };
}

export function resetCustomerUserEmail(customerUserId: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, actions.RESET_CUSTOMER_USER_EMAIL, SignUpRequestApi.resetCustomerUserEmail(customerUserId));
        dispatch(resetEmailSuccess(customerUserId));
        toast.success("Email has been reset");
    };
}

export function resetEmployeeUserEmail(customerId: string, employeeId: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, actions.RESET_EMPLOYEE_USER_EMAIL, SignUpRequestApi.resetEmployeeUserEmail(customerId, employeeId));
        dispatch(resetEmailSuccess(employeeId));
        toast.success("Email has been reset");
    };
}

export const requestSignUpEmailSuccess = (id: string): RequestSignUpEmailAction => ({
    payload: id,
    type: actions.REQUEST_SIGNUP_EMAIL_SUCCESS
});

export const resetEmailSuccess = (id: string): ResetUserEmailAction => ({
    payload: id,
    type: actions.RESET_USER_EMAIL_SUCCESS
});
